import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { FilterType } from '../../../../enum/FilterType';
import HeaderFiltersSetup from './HeaderFilterSetup';
import CashRegisterFiltersSetup from './CashRegisterFilterSetup';

const FiltersSetup = () => {
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const group = useAppSelector((state) => state.globalFilters.Group);
  const hasGroup = Boolean(group?.length);

  const [showFilters, setShowFilters] = useState(filterType === FilterType.CASH_REGISTER_FILTERS && !hasGroup);

  useEffect(() => {
    if (filterType === FilterType.CASH_REGISTER_FILTERS) {
      setShowFilters(!hasGroup);
    }
    // eslint-disable-next-line
  }, [filterType]);

  const content = (
    <>
      {filterType === FilterType.NORMAL ? (
        <HeaderFiltersSetup />
      ) : (
        <CashRegisterFiltersSetup setShowFilters={setShowFilters} />
      )}
    </>
  );

  return (
    <>
      <div
        className={`cash_register_wrapper ${isSidebarMinimized ? 'minimized' : ''} ${filterType === FilterType.CASH_REGISTER_FILTERS && showFilters && 'show_filters'}`}
      ></div>
      {content}
    </>
  );
};

export default FiltersSetup;
